import { createAction } from 'lib/store-utils';
import { Permission, StringMap } from 'type';

export const BOX_PERMISSIONS_REQUEST = createAction('Get permissions');
export const BOX_PERMISSIONS_SUCCESS = createAction<StringMap<Permission>>('Get permissions success');
export const BOX_PERMISSIONS_FAILURE = createAction<string[]>('Get permissions failed');
